import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54d8028a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=54d8028a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8028a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d8028a')) {
      api.createRecord('54d8028a', component.options)
    } else {
      api.reload('54d8028a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=54d8028a&scoped=true&", function () {
      api.rerender('54d8028a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/pricingScheme/index.vue"
export default component.exports